// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import DriversList from './DriversList';

export default compose(
  connect(
    state => ({
      user: state?.global?.user || {},
    }),
    dispatch => ({}),
  ),
)(DriversList);
